module.exports = "/_next/static/images/2fbad1c154543d2563c74f772af8e048-hero-patadita-dorada-1x.jpg.webp";